import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { BRAND, BRAND_ICON_RADIUS } from '../../brand/brand';
import logoImage from '../../logo.png';

/**
 * The Anipaw lockup: the real app icon plus the product name. Used on the pre-dashboard
 * screens, matching the icon + wordmark pairing in the dashboard sidebar.
 */
const BrandMark = ({ size = 72, title, subtitle }) => (
  <Stack alignItems="center" spacing={2}>
    <Box
      component="img"
      src={logoImage}
      alt="Anipaw"
      draggable={false}
      sx={{
        width: size,
        height: size,
        borderRadius: BRAND_ICON_RADIUS,
        display: 'block',
        boxShadow: `0 10px 26px ${BRAND.purple700}3D, 0 2px 6px rgba(20,16,30,0.12)`,
      }}
    />
    {title && (
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 800,
          letterSpacing: '-0.02em',
          color: BRAND.ink900,
          textAlign: 'center',
          fontSize: { xs: '1.6rem', sm: '2rem' },
        }}
      >
        {title}
      </Typography>
    )}
    {subtitle && (
      <Typography
        variant="body1"
        sx={{ color: BRAND.ink500, textAlign: 'center', maxWidth: 460 }}
      >
        {subtitle}
      </Typography>
    )}
  </Stack>
);

export default BrandMark;
